import Vue from "vue";
import VueRouter from "vue-router";

import home from "@/views/website/paginaPrincipal/PaginaPrincipal.vue";
import vistaGaleria from "@/views/website/VistaGaleria.vue";
import vistaCarreteImagenes from "@/components/galeria/VistaCarreteImagenes.vue";
import vistaNoticias from "@/views/website/VistaNoticias.vue";
import vistaNoticia from "@/views/website/VistaNoticia.vue";
import eventos from "@/views/website/CalendarioEventos.vue";
import homeWebSite from "../views/website/HomeWebSite.vue";
import vistaNoticiasCaritas from "@/views/website/caritas/VistaCaritasNoticias.vue";
import paginaContenido from "@/views/website/paginas/PaginaContenido.vue";
import caritasColabora from "@/views/website/caritas/CaritasColabora.vue";
import contenidoHistoria from "@/contenido/historia.js";
import contenidoSanJudas from "@/contenido/sanJudas.js";
import dashboard from "@/views/dashboard/Dashboard.vue";
import login from "@/views/dashboard/LoginView.vue";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/login",
    name: "login",
    component: login,
    meta: { guestOnly: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    component: homeWebSite,
    children: [
      {
        path: "",
        name: "inicio",
        component: home,
      },
      {
        path: "CaritasParroquialNoticias",
        name: "CaritasParroquialNoticias",
        component: vistaNoticiasCaritas,
      },
      {
        path: "noticia",
        name: "noticia",
        component: vistaNoticia,
        meta: { noCache: true },
      },
      {
        path: "Multimedia",
        name: "Multimedia",
        component: vistaGaleria,
        meta: { noCache: true },
      },
      {
        path: "Eventos",
        name: "Eventos",
        component: eventos,
        meta: { noCache: true },
      },
      {
        path: "carrete",
        name: "carrete",
        component: vistaCarreteImagenes,
        meta: { noCache: true },
      },
      {
        path: "caritas/colabora",
        name: "caritasColabora",
        component: caritasColabora,
      },
      {
        path: "historia",
        name: "historia",
        component: paginaContenido,
        props: { contenido: contenidoHistoria },
      },
      {
        path: "san-judas-tadeo",
        name: "sanJudas",
        component: paginaContenido,
        props: { contenido: contenidoSanJudas },
      },
      {
        path: "vistaNoticias",
        name: "vistaNoticias",
        component: vistaNoticias,
        meta: { noCache: true },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // Atrás/adelante: vuelve a donde estaba. #seccion: baja a ella (bajo la barra fija). Resto: arriba.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          let existe = false;
          try {
            existe = !!document.querySelector(to.hash);
          } catch (e) {
            existe = false; // #algo que no es un selector válido
          }
          resolve(existe ? { selector: to.hash, offset: { x: 0, y: 110 }, behavior: "smooth" } : { x: 0, y: 0 });
        }, 300);
      });
    }
    if (to.path === from.path) return false; // solo cambia la consulta (?fecha=…): no se mueve
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token_parmada");

  if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
    next({ name: "login" });
    return;
  }

  if (to.matched.some((record) => record.meta.guestOnly) && token) {
    next({ name: "dashboard" });
    return;
  }

  next();
});

export default router;
